import { FileService } from "../../services/file.service";
import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { UtilsService } from "../../services/utils.service";
import AppConstants from "../../constants/AppConstants";
import { LocationsService } from "../../services/locations.service";
import { AttractionsService } from "../../services/attractions.service";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: "app-all-videos",
  templateUrl: "./all-videos.component.html",
  styleUrls: ["./all-videos.component.scss"],
})
export class AllVideosComponent implements OnInit {
  private pageIndex: number;

  constructor(
    private graphqlService: ApiService,
    private utilsService: UtilsService,
    private locationService: LocationsService,
    private attractionService: AttractionsService,
    private fileService: FileService,
  ) {}
  videos: any[];
  totalCount: number;
  entityType: string;
  loading = false;
  locations: any[];
  attractions: any[];
  selectedLocationId: string;
  selectedAttractionId: string;
  idLabel: string;

  ngOnInit() {
    this.pageIndex = 0;
    this.getAllVideos();
    this.getAllAttraction();
    this.getAllLocation();
  }

  getAllVideos() {
    let obj: any;
    obj = {
      paginationData: {
        pageIndex: this.pageIndex,
        pageSize: AppConstants.DEFAULT_PHOTOS_PAGE_SIZE,
      },
    };

    if (this.selectedLocationId && this.selectedLocationId !== "all") {
      obj.locationId = this.selectedLocationId;
    } else if (
      this.selectedAttractionId &&
      this.selectedAttractionId !== "all"
    ) {
      obj.attractionId = this.selectedAttractionId;
    }

    this.loading = true;
    this.graphqlService.getAllVideos(obj).subscribe((res) => {
      const data = res.data;
      if (data && data["videos"]) {
        this.totalCount = data["videos"].totalCount;
        if (this.videos && this.pageIndex !== 0) {
          this.videos = this.videos.concat(
            data["videos"].edges.map((edge) => edge.node),
          );
        } else {
          this.videos = data["videos"].edges.map((edge) => edge.node);
        }

        this.utilsService.openSnackBar("Videos Loaded !!", "");
        this.loading = false;
      }
    });
  }

  getAllLocation() {
    this.locationService.getAllLocation().subscribe((res) => {
      const data = res.data;
      if (data && data["allLocations"]) {
        this.locations = data["allLocations"];
      }
      console.log("all", data);
    });
  }

  changeLocation() {
    this.selectedAttractionId = "";
    this.idLabel = "locationId";
    this.filter();
  }

  getAllAttraction() {
    this.attractionService.getAllAttraction().subscribe((res) => {
      const data = res.data;
      if (data && data["allAttractions"]) {
        this.attractions = data["allAttractions"];
      }
    });
  }
  changeAttraction() {
    this.selectedLocationId = "";
    this.idLabel = "attractionId";
    this.filter();
  }

  loadMore() {
    this.pageIndex++;
    this.getAllVideos();
  }

  filter() {
    this.pageIndex = 0;
    this.getAllVideos();
  }
  photoChanged(index) {
    if (!this.loading && index + 5 >= this.videos.length) {
      this.loadMore();
    }
  }

  getId() {
    if (this.selectedLocationId) {
      return this.selectedLocationId;
    } else if (this.selectedAttractionId) {
      return this.selectedAttractionId;
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/all-videos/all-videos.component.ts